import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from 'containers/AccessControl/actions';
import * as globalActions from 'store/global/actions';
import { initializePortfolioBrands } from 'containers/Portfolio/PageHeader/actions';
import { OTHER_ROUTES } from 'utils/routes';
import AccessControlUtils from 'utils/access-control';
import { BrandType } from 'utils/types';
import FeatureToggle from 'utils/feature-toggle-utils';
import { GET_CLIENT_CATEGORY, GET_BRAND_LIST_BY_CLIENT } from 'apollo/queries';
import { AuthSession } from '@spins/react-sso-provider';
import { APP_INIT } from 'containers/AccessControl/actionTypes';

function* appInitSaga({
  payload
}: {
  payload: { authSession: AuthSession; client: any; history: any };
}) {
  const activeClient = payload.authSession.user.clients.find(client => client.is_active);
  if (activeClient) {
    let enterpriseClient: BrandType = null;
    let brandsListByClient: Array<BrandType> = [];
    let isEnterpriseClientWithPortfolio: Boolean = false;
    let clientData: { id: string; name: string } = { id: '', name: '' };
    try {
      const response = yield call(payload.client.query, {
        query: GET_CLIENT_CATEGORY,
        variables: {
          client: activeClient.client_id
        }
      });
      const getBrandListByClient = yield call(payload.client.query, {
        query: GET_BRAND_LIST_BY_CLIENT,
        variables: {
          clientID: activeClient.client_id,
          pageable: {
            page: 1,
            pageSize: 10000
          }
        }
      });
      enterpriseClient = AccessControlUtils.getEnterpriseClient(
        activeClient,
        response.data.getClientCategory.category
      );
      getBrandListByClient.data.getBrandListByClient &&
        (brandsListByClient = AccessControlUtils.getBrandsListByClient(
          getBrandListByClient.data.getBrandListByClient.data
        ));

      isEnterpriseClientWithPortfolio =
        !!enterpriseClient && FeatureToggle.isFeatureEnabled(FeatureToggle.FEATURES.PORTFOLIO);
      clientData = {
        id: isEnterpriseClientWithPortfolio ? enterpriseClient.id : activeClient.client_id,
        name: isEnterpriseClientWithPortfolio ? enterpriseClient.name : activeClient.client_name
      };
    } catch (e) {
      console.log(e);
    } finally {
      yield put(initializePortfolioBrands(brandsListByClient));
    }

    yield put(globalActions.setClientId(clientData.id));
    if (isEnterpriseClientWithPortfolio) {
      yield put(globalActions.setEnterpriseBrand(clientData.name));
    } else {
      yield put(globalActions.setCurrentBrand(clientData.name));
    }

    yield put(
      actions.setHamburgerMenuItems(
        AccessControlUtils.mapHamburgerMenuItems(activeClient, AccessControlUtils.getBaseCmsUrl())
      )
    );
  } else {
    console.log('No current client/brand is active, back to login.');
    payload.history.push(OTHER_ROUTES.REDIRECT_CMS_LOGIN);
  }
}

export default function* authenticationSagas() {
  yield takeEvery(APP_INIT as any, appInitSaga);
}
